import * as React from 'react';
import { HeadContent, Scripts, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { RouterContext } from '@/types/routerContext.tsx';
import Header from '@/components/molecules/Header';
import Footer from '@/components/molecules/Footer';


export const Route = createRootRouteWithContext<RouterContext>()({
  head:  () => ({
    meta: [
      {
        title: 'OMEO Cycles - Custom Built Bikes'
      },
      {
        charSet: 'UTF-8'
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0'
      }
    ],
    scripts: [
      {
        src: '/dist/__user__.js'
      },
      {
        src: '/dist/frontend.js',
        defer: true // Defer is mandatory otherwise React will try to rehydrate before the page has completed streaming.
      },
      {
        src: 'https://unpkg.com/@tailwindcss/browser@4',
      }
    ]
  }),
  component: RootComponent
});

function RootComponent() {
  const queryClient = new QueryClient();
  return (
    <html>
      <head>
        <HeadContent />
        <link rel="stylesheet" href="/dist/frontend.css" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Fredoka:wght@300..700&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet" />

      </head>
      <body>
        <div id="root">
          <QueryClientProvider client={queryClient}>
            <Header />
            <div className="page-container">
              <Outlet />
            </div>
            <Footer />
          </QueryClientProvider>
        </div>

        <Scripts />
      </body>
    </html>
  )
}
